module.exports = __webpack_public_path__ + "static/media/location-pin.e2fdce00.svg";